/** Public (user) site routes — dccommercial.com.au / :3000 */
export const USER_ROUTES = {
  home: '/',
} as const;

/**
 * Admin site URLs.
 */
export const ADMIN_ROUTES = {
  home: '/admin/dashboard',
  login: '/admin/login',
  forgotPassword: '/admin/login/forgot-password',
  resetPassword: (token: string) => `/admin/login/reset-password/${token}`,
  dashboard: '/admin/dashboard',
  enquiries: '/admin/enquiries',
  contacts: '/admin/general-enquiry',
  aboutUs: '/admin/about-us',
} as const;
